import { Link as GLink } from 'gatsby-plugin-react-i18next';
import { Box, css, Link as JLink } from 'juhuui';

export const Link = JLink.with({ as: GLink });
export const activeLinkClass = css({
  color: 'tom.textHighlight',
  borderBottom: '1px solid currentColor',
});

export const LinkFrame = Box.variants({
  animate: {
    true: {
      '&:hover .link-text': {
        transform: 'translateX(0.2rem)',
      },
      '& .link-text': {
        transition: 'transform 0.25s ease',
      },
      '& .link-icon g': {
        transition: 'all 0.25s ease',
      },
    },
  },
  icon: {
    hover: {
      '&:hover .link-icon g': {
        stroke: 'tom.textHighlight',
        color: 'tom.textHighlight',
      },
      '&:hover .link-icon path': { stroke: 'tom.textHighlight' },
    },
  },
  text: {
    hover: {
      '&:hover .link-text': { color: 'tom.textHighlight' },
    },
  },
}).with({ cursor: 'pointer' });
